"use client";

import styled from "@emotion/styled";
import { Fragment } from "react";
import SwitchWorkspace from "~/app/dashboard/components/SwitchWorkspace";
import { OCTOLANE_COLOR_TOKENS } from "~/app/styles/tokens";

import { Command } from "~/core/ui/Command";

import AntModal from "../AntModal";

import CommandbarContent from "./components/Content";
import CommandbarFilterTabs from "./components/FilterTabs";
import CommandbarFooter from "./components/Footer";
import CommandbarHeader from "./components/Header";
import { COMMANDBAR_WIDTH } from "./constants/common";
import { useCommandbarCommandItems } from "./hooks/useCommandbarCommandItems";
import { useCommandbarPageItems } from "./hooks/useCommandbarPageItems";
import { useOpeningShortcut } from "./hooks/useOpeningShortcut";
import { useSearchCommandbar } from "./hooks/useSearchCommandbar";
import { useGlobalCommandbarStore } from "./store";

const StyledModal = styled(AntModal)`
  .ant-modal-content {
    padding: 0 !important;
    border: 1px solid ${OCTOLANE_COLOR_TOKENS.border.light};
  }
`;

export default function GlobalCommandbar() {
  useOpeningShortcut();
  useSearchCommandbar();
  useCommandbarCommandItems();
  useCommandbarPageItems();

  const isOpenGlobalCommandbar = useGlobalCommandbarStore(
    st => st.isOpenGlobalCommandbar,
  );
  const activeCommandbarItemId = useGlobalCommandbarStore(
    st => st.activeCommandbarItemId,
  );
  const setActiveCommandbarItemId = useGlobalCommandbarStore(
    st => st.setActiveCommandbarItemId,
  );
  const setIsOpenGlobalCommandbar = useGlobalCommandbarStore(
    st => st.setIsOpenGlobalCommandbar,
  );
  const openSwitchWorkspaceModal = useGlobalCommandbarStore(
    st => st.openSwitchWorkspaceModal,
  );
  const setOpenSwitchWorkspaceModal = useGlobalCommandbarStore(
    st => st.setOpenSwitchWorkspaceModal,
  );
  const searchInputRef = useGlobalCommandbarStore(st => st.searchInputRef);

  return (
    <Fragment>
      <StyledModal
        width={COMMANDBAR_WIDTH}
        open={isOpenGlobalCommandbar}
        onCancel={() => setIsOpenGlobalCommandbar(false)}
      >
        <Command
          loop
          value={activeCommandbarItemId}
          onValueChange={setActiveCommandbarItemId}
          onClick={() => {
            searchInputRef?.current?.focus();
          }}
        >
          <CommandbarHeader />
          <CommandbarFilterTabs />
          <CommandbarContent />
          <CommandbarFooter />
        </Command>
      </StyledModal>

      <SwitchWorkspace
        open={openSwitchWorkspaceModal}
        onClose={() => setOpenSwitchWorkspaceModal(false)}
      />
    </Fragment>
  );
}
